import { Component, signal, WritableSignal } from '@angular/core';
import { BlockVideo } from '@src/app/@shared/models/step.model';
import { BlockAbstractComponent } from '@app/components/blocks/block.abstract.component';

@Component({
  selector: 'pl-block-video',
  templateUrl: './block-video.component.html',
})
export class BlockVideoComponent extends BlockAbstractComponent<BlockVideo, null> {
  protected override hostBindingClasses: WritableSignal<Set<string>> = signal(new Set(['block']));

  protected override initForm(): void {}

  protected override patchFormWithEmptyValue(): void {}

  protected override patchFormFromBlock(): void {}
}
